module.exports = __webpack_public_path__ + "img/square-sticker.a0dc8113.jpg";